module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AAHGJ3/Images/frn_fig_001.jpg?1690381984532",
      "alt": "This image is the cover for the book Typhoon Attack, Stackpole Military History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Typhoon Attack, Stackpole Military History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("• Lively tales of aerial combat in the legendary Typhoon fighter • History of the plane and the men who flew it in World War II • Based on interviews with the pilots themselves The Typhoon fighter played a pivotal role in the Allies' success in the air and on the ground in World War II, from the Normandy beachhead to the Battle of the Bulge and the final battle for Germany. Norman Franks describes what it was really like to fly at low level and attack trains and tanks or to roll over at 12,000 feet and then roar down into an inferno of German flak.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Norman Franks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Norman Franks is a respected historian and author.  Previous titles for Pen and Sword include InThe Footsteps of the Red Baron (co-authored with Mike OConnor), The Fighting Cocks, RAF Fighter Pilots Over Burma, Dogfight, The Fallen Few of the Battle of Britain (with Nigel McCrery) and Dowdings Eagles.  Over the course of his career, Frank has published some of the most compelling works on First World War fighter aviation, being one of the worlds leading authorities on the subject. He lives in Bexhill-on-Sea, East Sussex.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    STACKPOLE BOOKS\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0